import React, { useRef } from "react";
import PropTypes from "prop-types";
import CardStatus from "../../component-library/CardMeta/CardStatus";
import CardWrapper from "../../component-library/CardWrapper";
import CardFeaturedImage from "../../component-library/CardFeaturedImage";
import LaunchCardContent from "./LaunchCardContent";
import CardLongFooter from "../CardLong/CardLongFooter";

const LaunchCard = ({
  id = 1,
  children,
  cardClassName = "card__wrapper--launch",
  imageSrc = "",
  title = "",
  text = "",
  footerContent = ""
}) => {
  const containerRef = useRef(null);

  return (
    <CardWrapper
      cardType="launch"
      id={`LaunchCard-${id}`}
      className={cardClassName}
      ref={containerRef}
    >
      <CardFeaturedImage
        imageUrl={imageSrc}
        alt={title}
        className="card__featured-wrapper card__featured-wrapper--launch zoom-hover--card zoom-hover__outer"
        imgClassName="card__image--featured zoom-hover__inner"
        imageStyle={{
          borderRadius: "0px"
        }}
      />

      <LaunchCardContent title={title} text={text} />

      {React.Children.map(children, (child) => {
        return child;
      })}
    </CardWrapper>
  );
};

LaunchCard.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  footerContent: PropTypes.node
};

export default Object.assign(LaunchCard, {
  Content: LaunchCardContent,
  Status: CardStatus,
  Footer: CardLongFooter
});
